import React, { createContext, useState } from "react";
import { toast } from "react-toastify";
import { getMyTranscriptsApi } from "../api/Reads";

export const HomeContext = createContext();

const HomeProvider = ({ children }) => {
  const [myTranscripts, setMyTranscripts] = useState();
  const [myProficiency, setMyProficiency] = useState();
  const [regNoFromRedirect, setRegNoFromRedirect] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  //MY REQUESTS
  const getMyTranscripts = async (studentId, requestType) => {
    setIsLoading(true);
    try {
      let response = await getMyTranscriptsApi(studentId, requestType);
      if (response.success) {
        setMyTranscripts(response.data);
        setIsLoading(false);
      } else {
        toast.error(response.message || "Oops, Something went wrong");
        setIsLoading(false);
      }
    } catch ({ response }) {
      // const { title } = response?.data;
      toast.error("Oops, Something went wrong");
    }
  };

  return (
    <HomeContext.Provider
      value={{
        myTranscripts,
        myProficiency,
        getMyTranscripts,
        regNoFromRedirect,
        setRegNoFromRedirect,
        isLoading,
      }}
    >
      {children}
    </HomeContext.Provider>
  );
};
export default HomeProvider;
